import { render, staticRenderFns } from "./Audioicon.vue?vue&type=template&id=6d7d7bfc&scoped=true"
import script from "./Audioicon.vue?vue&type=script&lang=js"
export * from "./Audioicon.vue?vue&type=script&lang=js"
import style0 from "./Audioicon.vue?vue&type=style&index=0&id=6d7d7bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7d7bfc",
  null
  
)

export default component.exports